module.exports = __webpack_public_path__ + "media/images/flags/vu-25acc79729c1d8a104b6a5d1afc4c9fa.svg";